// Web replacement for react-native-device-info.
const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';

function model(): string {
  if (/iPhone/.test(ua)) return 'iPhone';
  if (/iPad/.test(ua)) return 'iPad';
  const android = ua.match(/Android [\d.]+; ([^;)]+)/);
  if (android) return android[1].trim();
  if (/Macintosh/.test(ua)) return 'Mac';
  if (/Windows/.test(ua)) return 'Windows PC';
  return 'Web';
}

const DeviceInfo = {
  getVersion: () => __APP_VERSION__,
  getBuildNumber: () => __APP_BUILD__,
  getModel: model,
  getSystemName: () => 'Web',
  getUniqueId: async () => 'web',
};

export default DeviceInfo;
